import React, { Component } from 'react';
import Tabs from 'components/Tabs';
import { getLiteral } from 'utils/getLiteral';
import { errorToast } from 'utils/toast';
import Status from 'containers/settings/deprecatedIntegrationsManagement/components/Status';
import Statistics from 'containers/settings/deprecatedIntegrationsManagement/components/Statistics';
import Settings from 'containers/settings/deprecatedIntegrationsManagement/components/Settings';
import { ModalSm } from 'components/modals';
import { TYPE_REGULAR } from 'constants/FieldTypes';
import './style.scss';

class IntegrationActive extends Component {
    state = {
        dataReady: false,
        dataProgress: 0,
        stepperAlertErrors: null,
        stepperModalCancelOpen: false,
        tabIndex: 0,
    };

    constructor(props) {
        super(props);
        this.fieldsObj = {};
        this.selectFieldsObj = {};
        this.fmUsersObj = { arr: [], obj: {} };
        this.extUsersObj = { arr: [], obj: {} };
        this.getIntegrationsExtFieldsCalled = false;
        this.selectFieldsEntitiesReady = [];
        this.selectFieldsReady = false;
        this.usersNormalize = true;
        this.usersReady = false;
        this.fieldsMatched = {};
    }

    componentDidMount() {
        const { providerId, getCronStatus } = this.props;
        getCronStatus(providerId);
        this.getIntegrationsData();
        this.getStatisticsData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.cronstatus &&
            nextProps.cronstatus !== this.props.cronstatus &&
            nextProps.cronstatus === 'no cron'
        ) {
            this.setTab(2);
        }
        if (!this.state.dataReady) {
            if (!this.props.fmFields && nextProps.fmFields !== this.props.fmFields) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
            if (!this.props.fmUsers && nextProps.fmUsers !== this.props.fmUsers) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
            if (!this.props.extFields && nextProps.extFields !== this.props.extFields) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
            if (!this.props.extUsers && nextProps.extUsers !== this.props.extUsers) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
            if (!this.props.fieldsConfig && nextProps.fieldsConfig !== this.props.fieldsConfig) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
            if (!this.props.usersConfig && nextProps.usersConfig !== this.props.usersConfig) {
                this.setState({ dataProgress: this.state.dataProgress + 100 / 6 });
            }
        }
    }

    componentDidUpdate() {
        const {
            integration,
            providerId,
            fmFields,
            fmUsers,
            extFields,
            extUsers,
            fieldsConfig,
            usersConfig,
            getIntegrationsExtFields,
            stepperFinish,
            integrationsStepperReset,
            error,
            errorType,
            resetError,
            getCronStatus,
            literals,
        } = this.props;
        let errorTitle,
            errorText = '';
        if (error) {
            switch (errorType) {
                case 'SET_INTEGRATIONS_USERS_CONFIG':
                    errorTitle =
                        literals['label_error_integration_title_users'] ||
                        'label_error_integration_title_users';
                    errorText =
                        literals['label_error_integration_description_users'] ||
                        'label_error_integration_description_users';
                    errorToast({ title: errorTitle, text: errorText });
                    resetError();
                    break;
                case 'SET_INTEGRATIONS_FIELDS_CONFIG':
                    errorTitle =
                        literals['label_error_integration_title_fields'] ||
                        'label_error_integration_title_fields';
                    errorText =
                        literals['label_error_integration_description_fields'] ||
                        'label_error_integration_description_fields';
                    errorToast({ title: errorTitle, text: errorText });
                    resetError();
                    break;
                case 'CREATE_OR_UPDATE_JOB':
                    errorTitle =
                        literals['label_integration_sync_title_nok_retry'] ||
                        'label_integration_sync_title_nok_retry';
                    errorText =
                        literals['label_integration_sync_description_nok_retry'] ||
                        'label_integration_sync_description_nok_retry';
                    errorToast({ title: errorTitle, text: errorText });
                    resetError();
                    break;
                default:
                    break;
            }
        }
        if (this.state.dataReady === false) {
            if (fmFields && fieldsConfig) {
                if (!extFields && !this.getIntegrationsExtFieldsCalled) {
                    this.getIntegrationsExtFieldsCalled = true;
                    Object.keys(fieldsConfig).forEach((entity) => {
                        this.selectFieldsEntitiesReady.push(false);
                        getIntegrationsExtFields(
                            integration,
                            fieldsConfig[entity].externalEntity,
                            entity,
                        );
                    });
                }
                if (extFields && !this.selectFieldsReady) {
                    Object.keys(fieldsConfig).forEach((entity, index) => {
                        const fields = fieldsConfig[entity].outgoing
                            ? extFields[entity]
                            : fmFields[entity];
                        const selectFields = fieldsConfig[entity].outgoing
                            ? fmFields[entity]
                            : extFields[entity];
                        const fieldKey = fieldsConfig[entity].outgoing ? 'value' : 'RestAPIName';
                        if (!this.selectFieldsEntitiesReady[index] && fields && selectFields) {
                            this.fieldsObj[entity] = fields.reduce(
                                (accum, el) => ({
                                    ...accum,
                                    [el[fieldKey]]: el,
                                }),
                                {},
                            );
                            this.createFieldsSelectObj(entity, selectFields);
                            this.selectFieldsEntitiesReady[index] = true;
                        }
                    });
                    this.selectFieldsReady = this.selectFieldsEntitiesReady.reduce((accum, val) => {
                        return accum && val;
                    });
                }
                if (extFields && this.selectFieldsReady) {
                    Object.keys(fieldsConfig).forEach((entity) => {
                        this.createFieldsConfigs(entity);
                    });
                }
            }
            if (this.usersNormalize && fmUsers && extUsers && usersConfig) {
                this.usersNormalize = false;
                this.createUsersSelectObj(fmUsers, 'fmUsersObj', 'name', 'id');
                this.createUsersSelectObj(extUsers, 'extUsersObj', 'Name', 'Id');
                this.setDisabledUsers();
                if (usersConfig.length === 0) this.autoMapUsers();
                this.fmUsersObj.arr = this.ceateUsersSelectArr(this.fmUsersObj.obj);
                this.extUsersObj.arr = this.ceateUsersSelectArr(this.extUsersObj.obj);
                this.usersReady = true;
            }
            if (usersConfig && this.selectFieldsReady && this.usersReady) {
                this.setState({ dataReady: true });
            }
        }
        if (stepperFinish) {
            this.setTab(0);
            getCronStatus(providerId);
            integrationsStepperReset();
        }
    }

    getIntegrationsData = () => {
        const {
            integration,
            getIntegrationsFmFields,
            getIntegrationsFmUsers,
            getIntegrationsExtUsers,
            getIntegrationsFieldsConfig,
            getIntegrationsUsersConfig,
        } = this.props;
        getIntegrationsFmFields();
        getIntegrationsFmUsers();
        getIntegrationsExtUsers(integration);
        getIntegrationsFieldsConfig(integration);
        getIntegrationsUsersConfig(integration);
    };

    getStatisticsData = () => {
        const { getSyncroLogs, getSyncroStats, integration } = this.props;
        getSyncroLogs(integration);
        getSyncroStats(integration);
    };

    //TABS
    setTab = (tabIndex) => {
        this.setState({ tabIndex });
    };

    handleTabChange = (event, value) => {
        this.setTab(value);
    };

    //USERS
    createUsersSelectObj = (users, usersObj, label, value) => {
        users.map((el) => {
            this[usersObj].obj[el[value]] = { name: el[label], isDisabled: false };
        });
    };

    ceateUsersSelectArr = (obj) => {
        let arr = [];
        Object.keys(obj).forEach((key) => {
            arr = [...arr, { label: obj[key].name, value: key, isDisabled: obj[key].isDisabled }];
        });
        return arr;
    };

    setDisabledUsers = () => {
        const { usersConfig } = this.props;
        if (usersConfig.length === 0) return;
        usersConfig.forEach((el) => {
            if (this.fmUsersObj.obj[el.IdFM]) {
                this.fmUsersObj.obj[el.IdFM].isDisabled = !!this.fmUsersObj.obj[el.IdFM];
            }
            if (this.extUsersObj.obj[el.IdExternal]) {
                this.extUsersObj.obj[el.IdExternal].isDisabled =
                    !!this.extUsersObj.obj[el.IdExternal];
            }
        });
    };

    autoMapUsers = () => {
        let autoUsersConfig = [];
        Object.keys(this.fmUsersObj.obj).forEach((fmUser) => {
            Object.keys(this.extUsersObj.obj).forEach((extUser) => {
                if (
                    !this.fmUsersObj.obj[fmUser].isDisabled &&
                    !this.extUsersObj.obj[extUser].isDisabled &&
                    this.fmUsersObj.obj[fmUser].name.toLowerCase() ===
                        this.extUsersObj.obj[extUser].name.toLowerCase()
                ) {
                    autoUsersConfig = [
                        ...autoUsersConfig,
                        {
                            IdFM: fmUser,
                            IdExternal: extUser,
                        },
                    ];
                    this.fmUsersObj.obj[fmUser].isDisabled = true;
                    this.extUsersObj.obj[extUser].isDisabled = true;
                }
            });
        });
        this.props.addIntegrationsUsersAutoConfig(autoUsersConfig);
    };

    //FIELDS
    createFieldsSelectObj = (entity, selectFields) => {
        const { fieldsConfig } = this.props;
        let readOnly = {};
        let inUse = {};
        const bidirectional = fieldsConfig[entity].bidirectional;
        const outgoing = fieldsConfig[entity].outgoing;
        const fieldKey = outgoing ? 'RestAPIName' : 'value';
        Object.keys(fieldsConfig[entity].fieldRelation).forEach((elKey) => {
            let el = fieldsConfig[entity].fieldRelation[elKey];
            if (el.readOnly) {
                readOnly[el.externalField] = true;
            } else if (bidirectional && el.externalField && el.externalField !== '') {
                inUse[el.externalField] = true;
            }
        });
        this.selectFieldsObj[entity] = {
            all: { arr: [], obj: {} },
            list: { arr: [], obj: {} },
            notList: { arr: [], obj: {} },
        };
        selectFields.map((el) => {
            let fieldType = 'notList';
            if ((!outgoing && el.type === 'picklist') || (outgoing && el.FMType !== TYPE_REGULAR)) {
                fieldType = 'list';
            }
            if (!readOnly[el[fieldKey]]) {
                let option;
                if (outgoing) {
                    option = {
                        label: el.Literal
                            ? `${getLiteral(el.Literal)} (${el.RestAPIName})`
                            : el.RestAPIName,
                        picklistValues: null,
                        type: fieldType,
                        value: el.RestAPIName,
                    };
                } else {
                    option = el;
                    option.label = `${el.label} (${el.value})`;
                }
                el['isDisabled'] = inUse[el[fieldKey]] ? true : false;
                this.selectFieldsObj[entity][fieldType].obj[el[fieldKey]] = option;
                this.selectFieldsObj[entity][fieldType].arr.push(option);
                this.selectFieldsObj[entity].all.obj[el[fieldKey]] = option;
                this.selectFieldsObj[entity].all.arr.push(option);
            }
        });
    };

    createFieldsConfigs = (entity) => {
        const { fieldsConfig, setInitialIntegrationsFieldsConfig } = this.props;
        const outgoing = fieldsConfig[entity].outgoing;
        const fields = this.fieldsObj[entity];
        let newFieldsConfig = fieldsConfig;
        Object.keys(fields).forEach((key) => {
            if (outgoing) {
                let config = fieldsConfig[entity]['fieldRelation'][fields[key]['value']];
                if (!config) {
                    config = {
                        defaultValue: null,
                        externalField: fields[key]['value'],
                        externalRelatedTable: null,
                        forcemanagerField: null,
                        forcemanagerRelatedTable: null,
                        FMType: -1,
                        mandatory: false,
                        type: -1,
                        extType: fields[key]['type'],
                    };
                    newFieldsConfig[entity].fieldRelation[key] = config;
                }
            } else {
                let config = fieldsConfig[entity]['fieldRelation'][fields[key]['RestAPIName']];
                if (!config) {
                    config = {
                        defaultValue: null,
                        externalField: '',
                        externalRelatedTable: '',
                        forcemanagerField: fields[key]['RestAPIName'],
                        forcemanagerRelatedTable: fields[key]['RestAPILinkedTable'],
                        FMType: fields[key]['FMType'],
                        mandatory: fields[key]['Mandatory'],
                        type: fields[key]['Type'],
                        extType: '',
                    };
                    newFieldsConfig[entity].fieldRelation[key] = config;
                }
            }
        });
        setInitialIntegrationsFieldsConfig(newFieldsConfig);
    };

    handleFieldsSelChange = (entity, fieldType, field, oldValue, newValue, actionMeta) => {
        const { fieldsConfig, addIntegrationsFieldsConfig } = this.props;
        const bidirectional = fieldsConfig[entity].bidirectional;
        const outgoing = fieldsConfig[entity].outgoing;
        const data = {
            defaultValue: null,
        };
        const value = actionMeta.action === 'clear' ? null : newValue.value;
        if (outgoing) {
            data.forcemanagerField = value;
        } else {
            data.externalField = value;
        }
        addIntegrationsFieldsConfig(entity, field, data);
        // if (bidirectional) {
        //     if (oldValue) {
        //         this.selectFieldsObj[entity][fieldType].obj[oldValue].isDisabled = false;
        //     }
        //     if (newValue && newValue.value) {
        //         this.selectFieldsObj[entity][fieldType].obj[newValue.value].isDisabled = true;
        //     }
        //     this.createFieldsExtSelectArr(entity, 'all');
        //     this.createFieldsExtSelectArr(entity, fieldType);
        // }
    };

    handleFieldsDefaultChange = (entity, fieldType, field, newValue, actionMeta) => {
        let data = {};
        switch (fieldType) {
            case 'list':
                data = {
                    defaultValue: actionMeta.action === 'clear' ? null : newValue.value,
                };
                break;
            default:
                data = {
                    defaultValue: newValue,
                };
        }
        this.props.addIntegrationsFieldsConfig(entity, field, data);
    };

    handleAddUser = (fmUser, extUser) => {
        let data = {
            IdFM: fmUser.value,
            IdExternal: extUser.value,
        };
        this.props.addIntegrationsUsersConfig(data);
        this.fmUsersObj.obj[fmUser.value].isDisabled = true;
        this.extUsersObj.obj[extUser.value].isDisabled = true;
        this.fmUsersObj.arr = this.ceateUsersSelectArr(this.fmUsersObj.obj);
        this.extUsersObj.arr = this.ceateUsersSelectArr(this.extUsersObj.obj);
        this.setState({ stepperAlertErrors: null });
    };

    handleDeleteUser = (fmUser, extUser, index) => {
        this.fmUsersObj.obj[fmUser].isDisabled = false;
        this.extUsersObj.obj[extUser].isDisabled = false;
        this.fmUsersObj.arr = this.ceateUsersSelectArr(this.fmUsersObj.obj);
        this.extUsersObj.arr = this.ceateUsersSelectArr(this.extUsersObj.obj);
        this.props.deleteIntegrationsUsersConfig(index);
    };

    handleStepperSetSteps = (steps) => {
        this.props.integrationsStepperSetSteps(steps);
    };

    handleStepperClickPrev = () => {
        const { stage } = this.props;
        if (stage > 0) {
            this.setState({ stepperAlertErrors: null });
            this.props.integrationsStepperSetStage(stage - 1);
        }
    };

    handleStepperClickNext = () => {
        const {
            integration,
            stage,
            cronstatus,
            fieldsConfig,
            usersConfig,
            fmFields,
            setIntegrationsUsersConfig,
            setIntegrationsFieldsConfig,
            providerId,
            createOrUpdateJob,
            integrationsStepperReset,
            literals,
        } = this.props;
        switch (stage) {
            case 1:
                if (usersConfig.length === 0) {
                    this.setState({
                        stepperAlertErrors: {
                            ...this.state.stepperAlertErrors,
                            users: {
                                errors: true,
                                text: getLiteral(
                                    literals['label_error_integration_descript_users'] ||
                                        'label_error_integration_descript_users',
                                ),
                            },
                        },
                    });
                } else {
                    this.setState({
                        stepperAlertErrors: {
                            ...this.state.stepperAlertErrors,
                            users: {
                                errors: false,
                            },
                        },
                    });
                    setIntegrationsUsersConfig(integration, usersConfig, stage + 1);
                }
                break;
            case 2:
                let fields = { errors: false };
                let entityConfiguration = Object.keys(fieldsConfig).map((entityKey) => {
                    this.fieldsMatched[entityKey] = 0;
                    fields[entityKey] = {
                        ...fields[entityKey],
                        fm: {
                            errors: false,
                            obj: {},
                            title: getLiteral(
                                literals['label_integration_forcemanager_fields'] ||
                                    'label_integration_forcemanager_fields',
                            ),
                            text: '',
                        },
                        ext: {
                            errors: false,
                            obj: {},
                            title: getLiteral(
                                literals['label_integration_ext_fields'] ||
                                    'label_integration_ext_fields',
                            ),
                            text: '',
                        },
                    };
                    let entity = { ...fieldsConfig[entityKey] };
                    entity.fieldRelation = Object.keys(entity.fieldRelation).map((fieldKey) => {
                        let field = fields[entityKey];
                        let fieldConfig = entity.fieldRelation[fieldKey];
                        let fmField = fieldConfig.forcemanagerField;
                        let extField =
                            this.selectFieldsObj[entityKey].all.obj[fieldConfig.externalField];
                        let mandatoryNoReadOnly = fieldConfig.mandatory && !fieldConfig.readOnly;
                        let emptyDefaultValue =
                            !fieldConfig.defaultValue || fieldConfig.defaultValue === '';
                        let bidirectional = fieldsConfig[entityKey].bidirectional;
                        let outgoing = fieldsConfig[entityKey].outgoing;
                        if (bidirectional || (!bidirectional && !outgoing)) {
                            if (mandatoryNoReadOnly) {
                                field.fm.obj[fieldKey] = {
                                    extValue: false,
                                    defaultValue: false,
                                };
                                if (!extField) {
                                    fields.errors = true;
                                    field.fm.errors = true;
                                    field.fm.obj[fieldKey].extValue = true;
                                } else if (!extField.mandatory && emptyDefaultValue) {
                                    fields.errors = true;
                                    field.fm.errors = true;
                                    field.fm.obj[fieldKey].defaultValue = true;
                                }
                            }
                        }
                        if (bidirectional || (!bidirectional && outgoing)) {
                            // TODO - EXTERNAL MANDATORY
                            // if (mandatoryNoReadOnly) {
                            //     field.ext.obj[fieldKey] = {
                            //         extValue: false,
                            //         defaultValue: false,
                            //     };
                            //     if (!extField) {
                            //         fields.errors = true;
                            //         field.ext.errors = true;
                            //         field.ext.obj[fieldKey].extValue = true;
                            //     } else if (!extField.mandatory && emptyDefaultValue) {
                            //         fields.errors = true;
                            //         field.ext.errors = true;
                            //         field.ext.obj[fieldKey].defaultValue = true;
                            //     }
                            // }
                        }
                        if ((!outgoing && extField) || (outgoing && fmField)) {
                            this.fieldsMatched[entityKey]++;
                        }
                        return fieldConfig;
                    });
                    let fmLabelsArr = [];
                    Object.keys(fields[entityKey].fm.obj).forEach((fieldKey) => {
                        if (
                            fields[entityKey].fm.obj[fieldKey].extValue === true ||
                            fields[entityKey].fm.obj[fieldKey].defaultValue === true
                        ) {
                            fmLabelsArr.push(
                                getLiteral(fmFields[entityKey][fieldKey].Literal) || fieldKey,
                            );
                        }
                    });
                    fields[entityKey].fm.text =
                        getLiteral(
                            literals['label_error_integration_text_fields'] ||
                                'label_error_integration_text_fields',
                        ) +
                        ': ' +
                        fmLabelsArr.join(', ');

                    if (fieldsConfig[entityKey].bidirectional) {
                        fields[entityKey] = {
                            ...fields[entityKey],
                            ext: {
                                errors: false,
                                obj: {},
                                title: getLiteral(
                                    literals['label_integration_sl_fields'] ||
                                        'label_integration_sl_fields',
                                ),
                                text: '',
                            },
                        };
                        this.selectFieldsObj[entityKey].all.arr.forEach((el) => {
                            if (el.mandatory && !el.isDisabled) {
                                fields.errors = true;
                                fields[entityKey].ext.errors = true;
                                fields[entityKey].ext.obj[el.label] = true;
                            }
                        });
                        let extLabelsArr = [];
                        Object.keys(fields[entityKey].ext.obj).forEach((fieldKey) => {
                            if (fields[entityKey].ext.obj[fieldKey] === true) {
                                extLabelsArr.push(
                                    getLiteral(fmFields[entityKey][fieldKey].Literal || fieldKey),
                                );
                            }
                        });
                        fields[entityKey].ext.text =
                            getLiteral(
                                literals['label_error_integration_text_fields'] ||
                                    'label_error_integration_text_fields',
                            ) +
                            ': ' +
                            extLabelsArr.join(', ');
                    }
                    return entity;
                });
                if (fields.errors) {
                    this.setState({
                        stepperAlertErrors: {
                            ...this.state.stepperAlertErrors,
                            fields,
                        },
                    });
                    window.scrollTo(0, document.getElementById('fields-mapping').offsetTop);
                } else {
                    let data = { entityConfiguration: entityConfiguration };
                    if (cronstatus === 'no cron') {
                        setIntegrationsFieldsConfig(integration, data, stage + 1);
                    } else {
                        setIntegrationsFieldsConfig(integration, data, null);
                        this.setState({
                            stepperAlertErrors: null,
                        });
                        this.setTab(0);
                    }
                }
                break;
            case 3:
                if (cronstatus === 'no cron') {
                    createOrUpdateJob(providerId, integration);
                } else {
                    integrationsStepperReset();
                    this.setState({
                        stepperAlertErrors: null,
                    });
                    this.setTab(0);
                }
                break;
            default:
                break;
        }
    };

    handleStepperClickCancel = () => {
        this.setState({ stepperModalCancelOpen: true });
    };

    handleStepperCancelModalClickOk = () => {
        this.props.integrationsStepperCancel();
        this.setState({
            dataReady: false,
            dataProgress: 0,
            stepperAlertErrors: null,
            stepperModalCancelOpen: false,
        });
        this.fieldsObj = {};
        this.selectFieldsObj = {};
        this.fmUsersObj = { arr: [], obj: {} };
        this.extUsersObj = { arr: [], obj: {} };
        this.getIntegrationsExtFieldsCalled = false;
        this.selectFieldsEntitiesReady = [];
        this.selectFieldsReady = false;
        this.usersNormalize = true;
        this.usersReady = false;
        this.fieldsMatched = {};
        this.getIntegrationsData();
        this.setTab(0);
    };

    handleStepperCancelModalClickCancel = () => {
        this.setState({ stepperModalCancelOpen: false });
    };

    handleSettingsClickRetry = () => {
        this.props.resetError();
        this.getIntegrationsData();
    };

    handlePause = () => {
        this.props.pauseCron && this.props.pauseCron(this.props.providerId);
    };

    handleResume = () => {
        this.props.resumeCron && this.props.resumeCron(this.props.providerId);
    };

    handleRefreshCronStatus = () => {
        const { providerId, getCronStatus } = this.props;
        getCronStatus(providerId);
    };

    render() {
        const {
            integration,
            error,
            errorType,
            cronstatus,
            fieldsConfig,
            usersConfig,
            stage,
            steps,
            syncroStats,
            syncroLogs,
            valueList,
            getValueList,
            literals,
            integrationsStepperSetStage,
        } = this.props;

        let tabs = [
            {
                title: getLiteral(
                    literals['label_integration_status'] || 'label_integration_status',
                ),
                content: (
                    <Status
                        cronstatus={cronstatus}
                        pauseCron={this.handlePause}
                        resumeCron={this.handleResume}
                        refreshCronStatus={this.handleRefreshCronStatus}
                        goToSettings={() => this.setTab(2)}
                        literals={literals}
                        literal_enabled_text={
                            literals['label_enabled_sync_description_integration'] ||
                            'label_enabled_sync_description_integration'
                        }
                        literal_inprogress_text={
                            literals['label_sync_description_integration'] ||
                            'label_sync_description_integration'
                        }
                    />
                ),
            },
            {
                title: getLiteral(
                    literals['label_integration_statistics'] || 'label_integration_statistics',
                ),
                content: (
                    <Statistics
                        cronstatus={cronstatus}
                        syncroLogs={syncroLogs}
                        syncroStats={syncroStats}
                        integration={integration}
                        integrationLogo={'Sage_Financials_logo.jpg'}
                        literals={literals}
                    />
                ),
            },
            {
                title: getLiteral(
                    literals['label_integration_settings_single'] ||
                        'label_integration_settings_single',
                ),
                content: (
                    <Settings
                        dataReady={this.state.dataReady}
                        dataProgress={this.state.dataProgress}
                        error={error}
                        errorType={errorType}
                        fields={this.fieldsObj}
                        fmUsers={this.fmUsersObj}
                        selectFields={this.selectFieldsObj}
                        extUsers={this.extUsersObj}
                        fieldsConfig={fieldsConfig}
                        usersConfig={usersConfig}
                        onFieldsSelChange={this.handleFieldsSelChange}
                        onFieldsDefaultChange={this.handleFieldsDefaultChange}
                        onAddUser={this.handleAddUser}
                        onDeleteUser={this.handleDeleteUser}
                        stepperStage={stage}
                        stepperSteps={steps}
                        stepperSetSteps={this.handleStepperSetSteps}
                        stepperGoToStep={integrationsStepperSetStage}
                        onStepperClickPrev={this.handleStepperClickPrev}
                        onStepperClickNext={this.handleStepperClickNext}
                        onStepperClickCancel={this.handleStepperClickCancel}
                        getFmValuelist={getValueList}
                        fmValueList={valueList.toJSON()}
                        onClickRetry={this.handleSettingsClickRetry}
                        stepperAlertErrors={this.state.stepperAlertErrors}
                        fieldsMatched={this.fieldsMatched}
                        cronstatus={cronstatus}
                        literals={literals}
                    />
                ),
            },
        ];

        return (
            <div className="provider-container">
                <Tabs
                    className="provider-tabs"
                    content={tabs}
                    onChange={this.handleTabChange}
                    tabControlled={this.state.tabIndex}
                />
                <ModalSm
                    open={this.state.stepperModalCancelOpen}
                    title={getLiteral('action_discard_changes')}
                    literalConfirm={getLiteral('action_accept')}
                    literalCancel={getLiteral('action_cancel')}
                    onClose={this.handleStepperCancelModalClickCancel}
                    onConfirm={this.handleStepperCancelModalClickOk}
                    onCancel={this.handleStepperCancelModalClickCancel}
                    onClickOutside={this.handleStepperCancelModalClickCancel}
                >
                    {getLiteral(literals['label_cancel_operation'] || 'label_cancel_operation')}
                </ModalSm>
            </div>
        );
    }
}

export default IntegrationActive;
